// extracted by mini-css-extract-plugin
export default {"body":"styles_body__5pge+","alert":"styles_alert__bR3Ni","error":"styles_error__fypjx"};